import { useLingui } from "@lingui/react/macro";
import type { PluginCategory } from "@rakazo/core";

export function ConnectorIcon({
  name,
  logo,
  className = "h-9 w-9",
}: {
  name: string;
  logo?: string | null;
  className?: string;
}) {
  return logo ? (
    <img
      src={logo}
      alt=""
      loading="lazy"
      decoding="async"
      className={`${className} shrink-0 rounded-xl bg-accent object-contain`}
    />
  ) : (
    <div
      className={`${className} grid shrink-0 place-items-center rounded-xl bg-accent text-sm font-semibold text-foreground`}
    >
      {name[0]}
    </div>
  );
}

/** Display name for a marketplace category, shared by the app catalog and the template picker. */
export function usePluginCategoryLabel(): (name: string) => string {
  const { t } = useLingui();
  const labels: Record<PluginCategory, string> = {
    productivity: t`Productivity`,
    communication: t`Communication`,
    sales: t`Sales & CRM`,
    marketing: t`Marketing`,
    finance: t`Finance`,
    people: t`Recruiting & HR`,
    design: t`Design`,
    code: t`Developer`,
    data: t`Data`,
    ops: t`Security & Ops`,
  };
  return (name) => labels[name as PluginCategory] ?? name;
}
